export default __webpack_public_path__ + "static/media/img_woman.1161943b.png";